import BaseTrackingController from "../../../../../shared/src/ranj/equalture/platform/BaseTrackingController";
import InteractionEventName from "../data/InteractionEventName";

export default class TrackingController extends BaseTrackingController {

    constructor(dispatcher) {
        super(dispatcher);
    }

    
    /**
     * @param {ProgressValue} value 
     * @param {Number} elapsedTime
     */
     trackProgress(value, elapsedTime) {
        this._dispatchProgressEvent(value, elapsedTime);
    }

    /**
     * 
     * @param {Number} offset - Progress in race in pixels
     * @param {Boolean} rulesChanged 
     * @param {Number} correctLane - index of correct lane
     * @param {Number} maxSpeed - absolute value of max speed
     * @param {Number} elapsedTime
     */
    trackSectionChange(offset, rulesChanged, correctLane, maxSpeed, elapsedTime) {
        this._dispatchInteractionEvent(
            InteractionEventName.SECTION_CHANGE,
            { 
                offset: Math.round(offset),
                correct_lane: correctLane,
                max_speed: maxSpeed,
                rules_changed: rulesChanged 
            },
            elapsedTime
        );
    }


    /**
     * @param {Number} offset - Progress in race in pixels
     * @param {Number} lane - index of lane
     * @param {Number} speed - absolute value of speed
     * @param {Number} color - index of color
     * @param {Boolean} correct 
     * @param {Number} elapsedTime
     */
    trackLaneSwitch(offset, lane, speed, color, correct, elapsedTime) {
        this._dispatchInteractionEvent(
            InteractionEventName.LANE_SWITCH,
            {
                offset: Math.round(offset),
                lane: lane,
                speed: speed,
                color: color,
                correct: correct
            },
            elapsedTime
        );
    }
};
